import { PopupConfirm, PopupSuccess } from "@components/general/popup";
import { PermitService } from "@services/permit.service";
import { useThemeStore } from "@stores/theme.store";
import { useMutation } from "@tanstack/react-query";
import { Button, message, Tag } from "antd";
import { NoticeType } from "antd/es/message/interface";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
moment.locale("id");
export const PermitDetailPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [permitID, setPermitID] = useState<string>("");
  const [popupTitle, setPopupTitle] = useState<string>("");
  const [popupMessage, setPopupMessage] = useState<string>("");
  const [popupTextConfirm, setPopupTextConfirm] = useState<string>("");
  const [popupCancel, setPopupCancel] = useState<boolean>(false);
  const [popupSuccess, setPopupSuccess] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { mutate, isPending } = useMutation({
    mutationFn: PermitService.permitCancel,
    onSuccess: (response) => {
      if (response.success) {
        setPermitID("");
        setPopupCancel(false);
        setPopupSuccess(true);
      } else {
        setPopupCancel(false);
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  const onOpenPopupCancel = (id: string) => {
    setPermitID(id);
    setPopupTitle("Batalkan");
    setPopupMessage("Jika dibatalkan maka harus membuat ulang izin baru");
    setPopupTextConfirm("Ya, Batalkan");
    setPopupCancel(true);
  };

  const handleConfirm = (title: string) => {
    if (title === "Batalkan") {
      setPopupCancel(false);
      mutate({ id: permitID });
    }
  };

  useEffect(() => {
    setAppBar({ title: "Detail Perizinan", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Perizinan",
      image: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Status Izin</div>
          <div className="tw-mb-4">
            {state.acc === "Y" && (
              <Tag color="green" className="tw-text-xs ">
                Diizinkan
              </Tag>
            )}
            {state.acc === "N" && (
              <Tag color="red" className="tw-text-xs">
                Tidak Diizinkan
              </Tag>
            )}

            <Tag color="orange" className="tw-text-xs">
              Sedang dikonfirmasi
            </Tag>
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Tanggal Izin</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.datePermit ?? Date.now()).format("DD MMMM YYYY")}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">
            Jenis Perizinan
          </div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.mode ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">
            Nama Penjemput
          </div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.pickup ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Catatan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.notes ?? "-"}
          </div>
        </div>

        {state.status_izin === "MENUNGGU" && (
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            onClick={() => onOpenPopupCancel(state?.nourut ?? "")}
            className="tw-p-2 tw-mt-4 tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            {isPending ? "" : "Batalkan Permintaan Izin"}
          </Button>
        )}
      </div>

      <PopupConfirm
        open={popupCancel}
        title={popupTitle}
        message={popupMessage}
        textConfirm={popupTextConfirm}
        textCancel="Kembali"
        onConfirm={() => handleConfirm(popupTitle)}
        onCancel={() => setPopupCancel(false)}
      />

      <PopupSuccess
        open={popupSuccess}
        title="Berhasil!"
        message="Permintaan Izin berhasil dibatalkan"
        textConfirm="Kembali"
        onConfirm={() => navigate(-1)}
      />
    </>
  );
};
